export default {"src":"/_next/static/media/IconLargeMXGloves.c96fc684.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};